import { Box, CircularProgress, Typography, Alert, AppBar, Toolbar } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import axiosClient from '../../lib/axios';
import techpinesBackground from '../../assets/techpines-background-transparent.png';

export default function VerificarReceita() {
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const verificationTime = new Date().toLocaleString();

    const { data, isLoading } = useQuery({
        queryKey: ["verificar-receita", code],
        queryFn: () => axiosClient.get(`/verificar`, {
            params: { code, tipo: 'receita' },
        }),
        onSuccess: () => {
            enqueueSnackbar(`Receita verificada com sucesso!`, { variant: "success" });
        },
        onError: () => {
            enqueueSnackbar(`Erro ao verificar receita`, { variant: "error" });
        },
    });

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
                <Typography variant="body1" ml={2}>Verificando receita...</Typography>
            </Box>
        );
    }

    let result = null;

    if (data && data.data === true) {
        result = (
            <Alert severity="success" icon={false}>
                <Box display="flex" alignItems="center" justifyContent="center">
                    <img
                        src={"/imgs/finalizacao.png"}
                        alt="Logo"
                        style={{ width: 100, height: 100, marginBottom: 26 }}
                    />
                    <Typography variant="h4" color="textSecondary" ml={2}>
                        Receita válida!
                    </Typography>
                </Box>
                <Typography variant="body1">
                    Esta receita foi validada com sucesso. O documento é legítimo e foi emitido por Techpines.
                </Typography>
                <Typography variant="body2" color="textSecondary" mt={2}>
                    Verificação realizada em: {verificationTime}
                </Typography>
            </Alert>
        );
    }

    if (data && data.data === false) {
        result = (
            <Alert severity="error" icon={false}>
                <Typography variant="h4" gutterBottom>
                    <span role="img" aria-label="cross">❌</span> Receita Inválida!
                </Typography>
                <Typography variant="body1">
                    A verificação falhou. Esta receita não é legítima e não foi emitida por Techpines.
                </Typography>
                <Typography variant="body2" color="textSecondary" mt={2}>
                    Verificação realizada em: {verificationTime}
                </Typography>
            </Alert>
        );
    }

    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100vh" textAlign="center">
            <AppBar position="static" color="primary">
                <Toolbar>
                    <Box sx={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                        <img
                            src={techpinesBackground}
                            alt="Techpines Logo"
                            style={{ width: 200, height: 50, marginRight: 16 }}
                        />
                    </Box>
                </Toolbar>
            </AppBar>
            <Box maxWidth={600} margin="0 auto" padding={4}>
                {result}
                <Box mt={4}>
                    <Typography variant="caption">
                        Código de verificação: <strong>{code}</strong>
                    </Typography>
                </Box>
            </Box>

            <Box component="footer" bgcolor="primary.main" color="white" style={{ paddingTop: 10, paddingBottom: 10 }} textAlign="center">
                <Box display="flex" justifyContent="center" mb={1}>
                    <Box display="flex" alignItems="center" mr={3} style={{ marginTop: 0 }}>
                        <EmailIcon fontSize="small" style={{ marginRight: 4 }} />
                        <Typography variant="body2">
                            contato@techpines.com.br
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <InstagramIcon fontSize="small" style={{ marginRight: 4 }} />
                        <Typography variant="body2">
                            techpines
                        </Typography>
                    </Box>
                </Box>
                <Typography variant="body2" color="inherit" mt={1}>
                    &copy; 2024 Techpines. Todos os direitos reservados.
                </Typography>
            </Box>
        </Box>
    );
}